import { render } from "./Loading.vue?vue&type=template&id=48789790&scoped=true"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"

import "./Loading.vue?vue&type=style&index=0&id=48789790&lang=less&scoped=true"

import exportComponent from "D:\\gitdaima\\aibox-guanlixitong\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48789790"]])

export default __exports__